module.exports = __webpack_public_path__ + "img/bg.65c4920e.png";